module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "google-logo.5867462c.svg";